module.exports = __webpack_public_path__ + "static/image7-397e17d03bf622e35d685084555c2596.png";